import { render, staticRenderFns } from "./UserInfoLayout.vue?vue&type=template&id=0d6a52f8"
import script from "./UserInfoLayout.vue?vue&type=script&lang=js"
export * from "./UserInfoLayout.vue?vue&type=script&lang=js"
import style0 from "./UserInfoLayout.vue?vue&type=style&index=0&id=0d6a52f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports